import CheckOutlinedIcon from '@mui/icons-material/CheckOutlined';
import DoneAllOutlinedIcon from '@mui/icons-material/DoneAllOutlined';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';
import LockIcon from '@mui/icons-material/Lock';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import TaskOutlinedIcon from '@mui/icons-material/TaskOutlined';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Badge, Box, Fade, IconButton, List, ListItem, ListItemText, Paper, Tab } from '@mui/material';
import Popper from '@mui/material/Popper';
import { default as React, useEffect, useState } from 'react';
import { setPath } from 'src/store/Navigation';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import CRFQualityChecks from './CRFQualityChecks';
import './DataMonitoring.scss';
import VisitScheduleGridView from './VisitScheduleGridView';
import { ReactComponent as DataEntryComplete } from './icons/DataEntryComplete.svg'; //custom icon for legend
import { ReactComponent as DraftStatusIcon } from './icons/DraftStatusIcon.svg'; //custom icon for legend

const DataReview: React.FunctionComponent<any> = () => {
  const shapeStyles = { width: 20, height: 20 };
  const circle = <Box component="span" sx={{ ...shapeStyles }} />;
  const [open, setOpen] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [value, setValue] = useState('0');
  const dispatch = useAppDispatch();
  const fromNavigationPathName: any = useAppSelector((state: any) => {
    return state.navigationPath.navigationPathName;
  });
  const TabsData = [
    {
      lable: 'CRF Quality Checks',
      value: '0',
      cmp: CRFQualityChecks
    },
    {
      lable: 'Visit Log',
      value: '1',
      cmp: VisitScheduleGridView
    }
  ];

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
    setOpen(previousOpen => !previousOpen);
  };

  const handleTabsChange = (_: React.SyntheticEvent, newValue: any) => {
    setValue(newValue);
  };

  React.useEffect(() => {
    const handleOutsideClick = (event: MouseEvent) => {
      if (anchorEl && !anchorEl.contains(event.target as HTMLElement)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleOutsideClick);
    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, [anchorEl]);

  useEffect(() => {
    if (fromNavigationPathName !== '' && fromNavigationPathName !== null) {
      const pathFromTo = fromNavigationPathName.split(':');
      if (pathFromTo.length > 1 && pathFromTo[0] === 'dataReview') {
        pathFromTo[1] === 'crfQualityChecks' ? setValue('0') : setValue('1');
        dispatch(setPath(''));
      }
    }
  }, [fromNavigationPathName]);

  return (
    <>
      <IconButton
        aria-label="help"
        className="datareview-help-icon"
        onMouseEnter={handleClick}
        style={{ position: 'absolute', top: '72px', right: '24px', zIndex: '1000' }}
      >
        <HelpOutlineIcon />
      </IconButton>
      <TabContext value={value}>
        <TabList
          onChange={handleTabsChange}
          aria-label="Clinical Trial Data Review Tabs"
          sx={{ mt: -2 }}
          className="tabsFontSize extendedTabs"
        >
          {TabsData.map(ele => (
            <Tab label={ele.lable} value={ele.value} key={ele.value} />
          ))}
        </TabList>

        {TabsData.map(ele => (
          <TabPanel value={ele.value} sx={{ p: 0 }} key={ele.value}>
            <ele.cmp />
          </TabPanel>
        ))}
      </TabContext>
      <Popper id={'HelpLegend'} open={open} anchorEl={anchorEl} transition sx={{ mr: 2 }}>
        {({ TransitionProps }) => (
          <Fade {...TransitionProps} timeout={350}>
            <Paper>
              <List
                sx={{
                  width: '100%',
                  maxWidth: 360,
                  bgcolor: 'background.paper',
                  position: 'relative',
                  '& ul': { padding: 0 },
                  '& li': { padding: 0.5, paddingLeft: 2 }
                }}
              >
                <ul>
                  <ListItem sx={{ fontSize: '16px', fontWeight: '400', color: '#000', lineHeight: '30px' }}>
                    Legend
                  </ListItem>
                  <ListItem>
                    <InsertDriveFileOutlinedIcon color="disabled" />
                    <ListItemText sx={{ paddingLeft: '5px' }} primary={`Pending Data Entry`} />
                  </ListItem>
                  <ListItem>
                    <DraftStatusIcon />
                    <ListItemText sx={{ paddingLeft: '5px' }} primary={`Draft`} />
                  </ListItem>
                  <ListItem>
                    <DataEntryComplete />
                    <ListItemText sx={{ paddingLeft: '5px' }} primary={`Data Entry Complete`} />
                  </ListItem>
                  <ListItem>
                    <SearchOutlinedIcon sx={{ color: '#5073B9' }} />
                    <ListItemText sx={{ paddingLeft: '5px' }} primary={`Data Review Complete`} />
                  </ListItem>
                  <ListItem>
                    <CheckOutlinedIcon sx={{ color: '#5073B9' }} />
                    <ListItemText sx={{ paddingLeft: '5px' }} primary={`Source Data Review Complete`} />
                  </ListItem>
                  <ListItem>
                    <DoneAllOutlinedIcon sx={{ color: '#5073B9' }} />
                    <ListItemText sx={{ paddingLeft: '5px' }} primary={`Source Data Verification Complete`} />
                  </ListItem>
                  <ListItem>
                    <TaskOutlinedIcon color="success" />
                    <ListItemText sx={{ paddingLeft: '5px' }} primary={`CRF Signed`} />
                  </ListItem>
                  <ListItem>
                    <LockIcon color="success" />
                    <ListItemText sx={{ paddingLeft: '5px' }} primary={`CRF Locked`} />
                  </ListItem>
                  <ListItem>
                    <Badge className="badgeUser circle">{circle}</Badge>
                    <ListItemText primary={`Query for User`} />
                  </ListItem>
                  <ListItem>
                    <Badge className="badgeOtherUser circle">{circle}</Badge>
                    <ListItemText primary={`Query for Other User`} />
                  </ListItem>
                  <ListItem>
                    <Badge className="badgePending circle">{circle}</Badge>
                    <ListItemText primary={`Pending`} />
                  </ListItem>
                </ul>
              </List>
            </Paper>
          </Fade>
        )}
      </Popper>
    </>
  );
};

export default DataReview;
